import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

import { HStack, VStack } from "@/components/layout";
import { data, options } from "./config";
import StatementTypeLabel from "./statements-type-label";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels,
);

export default function StatementPagesChart() {
  return (
    <VStack className="h-[276px] w-full rounded-lg border bg-white p-4 shadow xl:w-1/2 2xl:w-2/3">
      <h4 className="text-cp-grey-600 mb-4 text-center font-normal lg:text-sm xl:text-base">
        Bank & Credit Statement Pages Uploaded (Last 6 Months)
      </h4>
      <HStack className="w-full items-center justify-between">
        <Bar data={data} options={options} />
      </HStack>
      <HStack className="mt-3 w-full justify-start lg:text-sm xl:text-base">
        <StatementTypeLabel className="before:bg-cp-purple-100 before:border-cp-purple-500">
          Credit statements
        </StatementTypeLabel>
        <StatementTypeLabel className="before:bg-cp-green-100 before:border-cp-green-500">
          Bank statements
        </StatementTypeLabel>
      </HStack>
    </VStack>
  );
}
